import type { ApiClient } from "@carepass/api-client";
import type { Schemas } from "../workspace/api.generated";
import type { TransactionSearchFormValues } from "./schema";

export interface TransactionListQuery {
  readonly status: TransactionSearchFormValues["status"];
  readonly keyword: string;
  readonly memberId?: number;
  readonly from: string;
  readonly to: string;
  readonly page: number;
  readonly size: number;
}

export async function getTransactions(
  apiClient: ApiClient,
  query: TransactionListQuery,
  signal?: AbortSignal,
): Promise<Schemas["AdminBoPageTransactionReviewQueueView"]> {
  const response = await apiClient.get<Schemas["AdminBoPageTransactionReviewQueueView"]>(
    "/api/v1/admin/bo/transaction-reviews",
    {
      query: {
        status: query.status || undefined,
        keyword: query.keyword || undefined,
        from: query.from || undefined,
        to: query.to || undefined,
        page: query.page,
        size: query.size,
      },
      signal,
    },
  );
  return response.data;
}

export async function getTransactionDetail(
  apiClient: ApiClient,
  transactionId: number,
  signal?: AbortSignal,
): Promise<Schemas["TransactionAdminDetailView"]> {
  const response = await apiClient.get<Schemas["TransactionAdminDetailView"]>(
    `/api/v1/admin/transactions/${transactionId}`,
    { signal, cache: "no-store" },
  );
  return response.data;
}

export async function claimTransactionReview(
  apiClient: ApiClient,
  transactionId: number,
  signal?: AbortSignal,
): Promise<Schemas["TransactionView"]> {
  const response = await apiClient.post<Schemas["TransactionView"]>(
    `/api/v1/admin/transactions/${transactionId}/reviews/claim`,
    undefined,
    { signal, cache: "no-store" },
  );
  return response.data;
}

export async function decideTransactionReview(
  apiClient: ApiClient,
  transactionId: number,
  input: Schemas["DecideTransactionReviewRequest"],
  signal?: AbortSignal,
): Promise<Schemas["TransactionView"]> {
  const response = await apiClient.post<
    Schemas["TransactionView"],
    Schemas["DecideTransactionReviewRequest"]
  >(`/api/v1/admin/transactions/${transactionId}/reviews/decision`, input, {
    signal,
    cache: "no-store",
  });
  return response.data;
}

export async function requestTransactionSupplement(
  apiClient: ApiClient,
  transactionId: number,
  input: Schemas["RequestTransactionSupplementRequest"],
  signal?: AbortSignal,
): Promise<Schemas["TransactionSupplementView"]> {
  const response = await apiClient.post<
    Schemas["TransactionSupplementView"],
    Schemas["RequestTransactionSupplementRequest"]
  >(`/api/v1/admin/transactions/${transactionId}/reviews/supplement-requests`, input, {
    signal,
    cache: "no-store",
  });
  return response.data;
}
